// Template Generated by DataExtraction.py at 1716507313
        
import AchieversPlanSummaryEN4 from "../../Forms/Plan Summaries/Achievers Plan Summary-EN-4.png";
import AchieversPlanSummaryEN4Labels from "../../Labels/Plan Summaries/Achievers Plan Summary-EN-4.json";
import AchieversPlanSummaryFR4 from "../../Forms/Plan Summaries/Achievers Plan Summary-FR-4.png";
import AchieversPlanSummaryFR4Labels from "../../Labels/Plan Summaries/Achievers Plan Summary-FR-4.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? AchieversPlanSummaryFR4Labels : AchieversPlanSummaryEN4Labels;
    const formImage = isFrench ? AchieversPlanSummaryFR4 : AchieversPlanSummaryEN4;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const common = data.common;
    const signDate = moment(new Date()).format("YYYY-MM-DD");



    // Drawing the form
    drawText(signDate, "drSignDate");
    drawText(signDate, "s1SignDate");
    if (common.subscriber2Include) {
        drawText(signDate, "s2SignDate");
    }
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? AchieversPlanSummaryFR4Labels : AchieversPlanSummaryEN4Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];

    const subscriber2Include = state.common.subscriber2Include;
    
    
    // s1Signature
    signers.push({
        [subscriberRecipientId]: [signatureTab(subscriberRecipientId, documentId, pageNumber, signatureLabel("s1SignatureView", labels))],
    });
    

    if (subscriber2Include) {
        // s2Signature
        signers.push({
            [jointSubscriberRecipientId]: [signatureTab(jointSubscriberRecipientId, documentId, pageNumber, signatureLabel("s2SignatureView", labels))],
        });
    }
    
    
    // drSignature
    signers.push({
        [DRRecipientId]: [signatureTab(DRRecipientId, documentId, pageNumber, signatureLabel("drSignatureView", labels))],
    });
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    